import { loginData } from '../types/login.interface'
import { GetterTree, MutationTree, ActionTree } from 'vuex'

const state: loginData = {
    token: '',
    platform: '',
    theFirstLink: '',
    deviceId: '',
    appChannel: '',
    userId: '',
    version:'',
    avatar: '',
    nickname: '',
    svipInfo: {}
}

const getters: GetterTree<loginData, any> = {
    
}

const mutations: MutationTree<loginData> = {
    UPDATE_TOKEN(state: loginData, value: string) {
        state.token = value;
    },
    UPDATE_PLATFORM(state: loginData, value: string) {
        state.platform = value;
    },
    UPDATE_THEFIRSTLINK(state: loginData, value: string) {
        state.theFirstLink = value;
    },
    UPDATE_DEVICEID(state: loginData, value: string) {
        state.deviceId = value;
    },
    UPDATE_APPCHANNEL(state: loginData, value: string) {
        state.appChannel = value;
    },
    UPDATE_USERID(state: loginData, value: string) {
        state.userId = value;
    },
    UPDATE_VERSION(state: loginData, value: string) {
        state.version = value;
    },
    UPDATE_AVATAR(state: loginData, value: string) {
        state.avatar = value;
    },
    UPDATE_NICKNAME(state: loginData, value: string) {
        state.nickname = value;
    },
    UPDATE_SVIPINFO(state: loginData, value: any) {
        state.svipInfo = value;
    },
}

const actions: ActionTree<loginData, any> = {

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}